import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import { dataService } from "../../Services/data.service";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PasswordDialog from '../Dialogs/PasswordDialog';

export default function Broker(props) {

  const [broker, setBroker] = useState(null)
  const [brokers, setBrokers] = useState([])
  const [dialogVisible, setDialogVisible] = useState(false)
  const [dialogTitle, setDialogTitle] = useState(null)
  const classes = useStyles();

  useEffect(() => {
    dataService.getBrokers().then(allBrokers => {

      if (JSON.stringify(brokers) !== JSON.stringify(allBrokers.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))) {
        setBrokers(allBrokers.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))
      }

      if (props.chosenValue) {
        if (JSON.stringify(broker) !== JSON.stringify(allBrokers.Results.find(x => x.Name === props.chosenValue))) {
          setBroker(allBrokers.Results.find(x => x.Name === props.chosenValue))
        }      
      }
     
    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

  }, [])

  const setNextStep = () => {
    validate();
  }

  const validate = () => {
    if (broker) {
      openPasswordDialog();

    } else {
      toast.error("Pick a broker", { position: toast.POSITION.TOP_CENTER })
    }
  }

  const save = (pin) => {
    if (broker) {
      props.setContent(broker.ID, broker.Name);
    }

    if (pin == broker.Pincode) {
      props.SetNext();
    } else {
      toast.error("Wrong password", { position: toast.POSITION.TOP_CENTER })
    }

    setDialogVisible(false)
  }

  const CloseDialog = () => {
    setDialogVisible(false)
  }

  const onChangeItem = (e) => {
    setBroker(brokers.find(x => x.ID === e.target.value))
  }

  const openPasswordDialog = () => {
    setDialogTitle("Enter administrator password")
    setDialogVisible(true)
  }
  if (broker) {
    console.log(broker.ID)

  }

  console.log(broker)
  return (
    <div className={classes.brokerContainer}>
      {brokers.length > 0 ?
        <React.Fragment>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            className={classes.brokerPicker}
            value={broker && broker.ID}
            onChange={(e) => onChangeItem(e)}
          >
            {brokers.map(x => {
              return (
                <MenuItem value={x.ID}>{x.Name}</MenuItem>)
            })}

          </Select>
          <PasswordDialog action={save} closeDialog={CloseDialog} dialogTitle={dialogTitle} dialogOpen={dialogVisible}></PasswordDialog>
          <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
        </React.Fragment>
        :
        <React.Fragment></React.Fragment>}
    </div>
  )
}



const useStyles = makeStyles({
  container: {
    flexDirection: "row"
  },
  filterField: {
    width: "80%",
    flex: 1,
    justifyContent: 'center'
  },
  buttonContainer: {
    width: "15%",
    flex: 1,
    justifyContent: 'center'
  },
  brokerPicker: {
    height: 44,
    backgroundColor: 'white',
    borderWidth: 1,
    marginBottom: 10,
    width: "100%"
  },
  brokerContainer: {
    marginTop: "30px"
  }
});